// Single source of truth for API + client version headers.
// SAYERMORE_API_VERSION is the date this client was built against — used by
// the server to branch behavior for backwards-incompatible breaking changes.
// CLIENT_VERSION is the build number — used for the force-update gate and
// telemetry.
//
// Both values are injected by esbuild at build time via `define`. Defaults
// are fine for `node webapp/serve-static.js` local dev without a build.

const env = (typeof process !== 'undefined' && process.env) || {};

export const API_VERSION = env.SAYERMORE_API_VERSION || '2026-05-24';
export const CLIENT_VERSION = env.CLIENT_VERSION || '0.1.0-dev';
